import React from 'react';
import { Link } from 'react-router-dom';
import '../stylesheets/NotFoundPage.css';

export function NotFoundPage() {
    return (
        <div className='NotFoundPage'>
            <h1>Էջը չի գտնվել</h1>
            <p>Ներեցեք, ձեր փնտրած էջը գոյություն չունի:</p>
            <Link to='/'>Վերադառնալ Գլխավոր էջ</Link>
        </div>
    );
}
